import { DelegatorResult, PaginatedResponse } from '@block-explorer/entities';
import { createAsyncAction } from 'typesafe-actions';
import { PaginationParams } from '../../services';

export const getActiveAccountDelegationsAsync = createAsyncAction(
  'GET_ACTIVE_ACCOUNT_DELEGATIONS_REQUEST',
  'GET_ACTIVE_ACCOUNT_DELEGATIONS_SUCCESS',
  'GET_ACTIVE_ACCOUNT_DELEGATIONS_FAILURE'
)<
  Partial<PaginationParams & { publicKey: string }>,
  PaginatedResponse<DelegatorResult>,
  string
>();
